import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';

export enum LocalStorageReservedKey {
  AnalyticsUserId = 'analytics_user_id',
}

export default function useLocalStorage() {
  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const composeKey = (key: LocalStorageReservedKey) => `company-${company?.id}-${key}`;

  const getItem = (key: LocalStorageReservedKey, defaultValue?: string): null | string =>
    localStorage.getItem(composeKey(key)) ?? defaultValue;
  const setItem = (key: LocalStorageReservedKey, value: string) => localStorage.setItem(composeKey(key), value);

  return {
    getItem,
    setItem,
  };
}
